export default __webpack_public_path__ + "static/media/loading2.f235a909.gif";